import { IntlShape } from 'react-intl';

import { INCONSISTENCIES_MESSAGES } from '../messages/inconsistencies.js';
import { Inconsistency } from '../types/inconsistency.js';

/**
 * Generate human-readable messages for detected inconsistencies.
 *
 * @param inconsistencies -
 * @param intl -
 */
export const buildInconsistenciesMessage = (
  inconsistencies: Record<Inconsistency, boolean>,
  intl: IntlShape,
) =>
  Object.entries(inconsistencies)
    .filter(([, isPresent]) => isPresent)
    .map(([key]) => ({
      severityLevel: 'warning',
      message: intl.formatMessage(
        INCONSISTENCIES_MESSAGES[key as Inconsistency],
      ),
    }));
